var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgLiveCasino = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9372_69897)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.9043 1.15045L9.49383 0.0201169C8.77283 -0.107018 8.08526 0.374428 7.95812 1.09543L7.89746 1.43952C8.82453 1.55374 9.60775 2.22158 9.85435 3.14181L10.2461 4.60391C10.4535 4.51396 10.6887 4.48155 10.928 4.52376C11.3821 4.60384 11.7305 4.93066 11.8603 5.34195C12.123 4.99986 12.5621 4.81189 13.0163 4.89198C13.6662 5.0066 14.1002 5.6264 13.9856 6.27635C13.7366 7.68861 12.2211 8.82373 11.5019 9.29059L12.5999 13.3886C12.6588 13.6083 12.6833 13.8291 12.6779 14.0457L13.6018 14.2086C14.3228 14.3357 15.0103 13.8543 15.1375 13.1333L16.9796 2.68623C17.1067 1.96516 16.6253 1.27759 15.9043 1.15045Z",
    fill: "#CCD6F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.89403 3.39938C8.73532 2.80711 8.19972 2.41647 7.61438 2.4165C7.50083 2.4165 7.38535 2.43121 7.27043 2.46199L0.982889 4.14672C0.275696 4.33621 -0.143992 5.06313 0.0454985 5.77032L2.7911 16.0171C2.94981 16.6094 3.48541 17 4.07075 17C4.1843 17 4.29978 16.9853 4.41466 16.9545L10.7022 15.2697C11.4094 15.0802 11.8291 14.3533 11.6396 13.6461L8.89403 3.39938ZM4.00132 10.4036C3.8947 10.3098 3.85489 10.1612 3.90031 10.0267L4.86174 7.17989C4.94216 6.94176 5.23906 6.8622 5.42779 7.02822L7.68381 9.0129C7.79043 9.1067 7.83024 9.25535 7.78482 9.38986L6.82339 12.2366C6.74297 12.4748 6.44606 12.5543 6.25734 12.3883L4.00132 10.4036Z",
    fill: "#CCD6F4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9372_69897"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 17,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLiveCasino);
export default ForwardRef;